var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from '@servicetitan/react-ioc';
import { observable, action, makeObservable } from 'mobx';
import { LOG_CONFIG_TOKEN } from './log-config';
let LogStorage = class LogStorage {
    constructor(logConfig) {
        var _a;
        Object.defineProperty(this, "logConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: logConfig
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "maxLogSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1000
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "nextItemId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        const version = window.parseInt(localStorage.getItem(this.storageVersionKey));
        if (version !== this.version) {
            localStorage.removeItem(this.storageKey);
            localStorage.setItem(this.storageVersionKey, String(this.version));
        }
        try {
            const items = (_a = JSON.parse(localStorage.getItem(this.storageKey))) !== null && _a !== void 0 ? _a : [];
            /* migrate error -> exception */
            items.forEach((item) => {
                if (typeof item.error === 'string') {
                    item.exception = item.error;
                    delete item.error;
                }
            });
            this.setItems(items);
        }
        catch (e) {
            this.setItems([]);
        }
        this.nextItemId = lastId(this.items);
    }
    get config() {
        return this.logConfig;
    }
    store(entry) {
        const item = {
            id: this.nextItemId++,
            type: entry.type,
            category: entry.category,
            code: entry.code,
            message: entry.message,
            data: JSON.stringify(entry.data),
            exception: this.stringifyError(entry.error),
        };
        let items = [...this.items, item];
        items = items.slice(-this.maxLogSize);
        this.setItems(items);
    }
    deleteToId(id) {
        const items = this.items.filter(item => item.id > id);
        this.setItems(items);
    }
    loadBatch(batchSize) {
        return this.items.slice(0, batchSize);
    }
    setItems(items) {
        this.items = [...items];
        localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    }
    get storageKey() {
        return this.logConfig.storageKey;
    }
    get storageVersionKey() {
        return `${this.storageKey}Version`;
    }
    stringifyError(error) {
        const detail = error ? { message: error.message.toString(), stack: error.stack } : null;
        return JSON.stringify(detail);
    }
};
__decorate([
    observable,
    __metadata("design:type", Array)
], LogStorage.prototype, "items", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LogStorage.prototype, "setItems", null);
LogStorage = __decorate([
    injectable(),
    __param(0, inject(LOG_CONFIG_TOKEN)),
    __metadata("design:paramtypes", [Object])
], LogStorage);
export { LogStorage };
export function lastId(items) {
    if (!items.length) {
        return 0;
    }
    const item = items[items.length - 1];
    return item.id;
}
//# sourceMappingURL=log-storage.js.map